var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconJoyJumping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 70,
    viewBox: "0 0 58 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.263 8.4445C19.3914 7.86121 20.6675 7.5247 22.0198 7.5247C23.3721 7.5247 24.7064 7.87018 25.8482 8.47591L23.8154 2.4456C23.1795 0.565615 21.1467 -0.443923 19.266 0.188721C17.3854 0.821365 16.3779 2.86288 17.0137 4.74286L18.2585 8.44001L18.263 8.4445ZM22.0192 21.8658C25.4072 21.8658 28.1536 19.1178 28.1536 15.7278C28.1536 12.3379 25.4072 9.58984 22.0192 9.58984C18.6312 9.58984 15.8848 12.3379 15.8848 15.7278C15.8848 19.1178 18.6312 21.8658 22.0192 21.8658ZM42.4509 42.4865C46.6286 44.0479 50.9406 46.9598 55.3422 50.8095H55.3467C57.6303 52.8062 57.9885 56.2476 56.0945 58.6166C52.5168 63.0945 48.7107 66.7961 43.7271 69.4344C41.6629 70.5292 39.115 69.9952 37.6867 68.1467C36.021 65.993 36.4822 62.8836 38.7031 61.3087L46.1405 56.0412C43.4808 53.3715 40.5524 51.5499 37.4493 50.2711C36.2672 54.5291 34.7851 58.841 33.0791 63.1932C31.9687 66.0289 28.3417 66.8589 26.0939 64.804C21.8312 60.9049 17.752 56.2207 13.8206 50.9397C12.2847 48.8757 12.7594 45.9458 14.8639 44.4651C16.8609 43.0608 19.6102 43.478 21.1058 45.4119C22.9774 47.8348 25.4581 50.989 27.2492 53.0215C30.1507 43.1595 27.5133 36.7478 22.0237 32.6109C17.9177 29.5195 2.09349 23.1123 2.09349 23.1123C0.288976 22.2822 -0.499098 20.151 0.329276 18.3473C1.15765 16.5436 3.28903 15.7539 5.08906 16.5839L21.8938 23.7404C22.2744 23.902 22.7043 23.884 23.0715 23.6956L25.27 22.5514C27.1686 21.5643 29.4611 21.6675 31.2343 22.8655C37.5479 27.128 41.3852 33.5801 42.4509 42.4865Z",
    fill: "url(#paint0_linear_616_12720)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_616_12720",
    x1: -4.6843,
    y1: 8,
    x2: 66.5091,
    y2: 21.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0274B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJoyJumping);
export default __webpack_public_path__ + "static/media/icon-joy-jumping.850674dc6098eb69c0643d5273064b9c.svg";
export { ForwardRef as ReactComponent };